'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { analytics } from 'utils/analytics';

const Analytics = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    analytics?.page({
      path: pathname,
    });
  }, [pathname, searchParams]);

  return null;
};

export default Analytics;
